import { routesBuilder } from '@guiker/shared-framework'

import { RentalContract, RentalOwner } from '../../../entity'
import { paths } from '../paths'
import { attachRentalContractSchema, upsertRentalOwnerPayload } from '../schemas'

const { buildPost, buildGet, buildPut } = routesBuilder<RentalOwner>()({ basePath: paths.user.withId.rentalOwner.path })

const { buildGet: buildGetRentalContracts } = routesBuilder<RentalContract[]>()({
  basePath: paths.rentalContracts.path,
})

export const routes = {
  upsertRentalOwner: buildPost({
    payloadSchema: upsertRentalOwnerPayload,
  }),
  readRentalOwnerByUserId: buildGet({}),
  attachRentalContractToRentalOwner: buildPut({
    path: '/attach-rental-contract',
    payloadSchema: attachRentalContractSchema,
  }),
  readAllRentalContracts: buildGetRentalContracts({}),
}
